import { HeadingTag, Maybe } from '@shared-components/types';

export default function getHeadingVariant(variant: Maybe<HeadingTag>) {
	switch (variant) {
		case 'h1':
			return 'header1';
		case 'h2':
			return 'header2';
		case 'h3':
			return 'header3';
		case 'h4':
			return 'header4';
		case 'normal':
			return 'bodyMediumBook';
		default:
			return 'header3';
	}
}

export function getHeadingLevel(variant: Maybe<HeadingTag>, fallback = 1) {
	switch (variant) {
		case 'h1':
			return 1;
		case 'h2':
			return 2;
		case 'h3':
			return 3;
		case 'h4':
			return 4;
		case 'normal':
			return fallback;
		default:
			return fallback;
	}
}
